import { put, takeLatest } from 'redux-saga/effects';
import { displayToast, ToastMessageProps } from './toastSlice';
import { watchList } from './watchList';

function* toastSaga(data: { payload: ToastMessageProps; type: string }) {
 //  console.log(data);
 yield put(
  displayToast({
   //    id: data.payload.id,
   type: data.payload.type,
   message: data.payload.message,
  }),
 );
}

export function* watchToastSaga() {
 yield takeLatest(
  watchList.map((action) => action.type),
  toastSaga,
 );
}
